var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import COLOURS from "../../styles/colours";
import { fonts } from "../../fonts";
var Speech = styled.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: ", ";\n  font-size: 2rem;\n  line-height: 1;\n  font-style: normal;\n  font-weight: normal;\n  color: ", ";\n  ", ";\n"], ["\n  font-family: ", ";\n  font-size: 2rem;\n  line-height: 1;\n  font-style: normal;\n  font-weight: normal;\n  color: ", ";\n  ", ";\n"])), fonts.speech, COLOURS.P100, function (p) { return (p.textAlign ? "text-align: " + p.textAlign : ""); });
export default Speech;
var templateObject_1;
